import { render, staticRenderFns } from "./HeadImg.vue?vue&type=template&id=95ffa522&scoped=true&"
import script from "./HeadImg.vue?vue&type=script&lang=js&"
export * from "./HeadImg.vue?vue&type=script&lang=js&"
import style0 from "./HeadImg.vue?vue&type=style&index=0&id=95ffa522&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95ffa522",
  null
  
)

export default component.exports